import type { Screen } from "../../app/api/ApiClient";
import type { StateStore } from "../../app/state/StateStore";

import { ScreenMapper } from "./ScreenMapper";

type ChangeSubscriptionsScreen =
    Extract<Screen, { type: "changeSubscriptions" }>;

export class ChangeSubscriptionsScreenMapper
    implements ScreenMapper<ChangeSubscriptionsScreen> {

    public readonly type =
        "changeSubscriptions" as const;

    constructor(
        private readonly store: StateStore
    ) {}

    public apply(
        screen: ChangeSubscriptionsScreen
    ): void {

        const state =
            this.store.getState();

        this.store.replace({

            ...state,

            primaryScreen: {

                type: "changeSubscriptions"

            },

            stickers:
                screen.available_stickers ?? [],

            currentSticker:
                screen.current_sticker ?? null,

            productTitle:
                screen.product_title ?? null,

            isLoading: false

        });

    }

}